import { useAuthInfo } from '@propelauth/react';

const ADMIN_ROLE = 'Admin';
const SUPERVISOR_ROLE = 'Supervisor';

export interface AuthPermissions {
  readOnly: boolean;
  isAtLeastSupervisor: boolean;
  isAdmin: boolean;
}

export const UseAuthPermissions = (): AuthPermissions => {
  const { accessHelper, orgHelper } = useAuthInfo();
  if (!accessHelper || !orgHelper) {
    return {
      readOnly: true,
      isAtLeastSupervisor: false,
      isAdmin: false,
    };
  }
  let readOnly = true;
  let isSupervisorOrUp = false;
  let isAdmin = false;
  const orgIds = orgHelper.getOrgIds();
  if (orgIds.length > 0) {
    const org = orgIds[0];
    isSupervisorOrUp = accessHelper.isAtLeastRole(org, SUPERVISOR_ROLE);
    isAdmin = accessHelper.isAtLeastRole(org, ADMIN_ROLE);
    readOnly = !isSupervisorOrUp;
  }

  return {
    readOnly,
    isAtLeastSupervisor: isSupervisorOrUp,
    isAdmin,
  };
};
